"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var canteenRouter = {
  path: '/canteen',
  component: _layout.default,
  redirect: '/canteen/list',
  name: 'Canteen',
  meta: {
    title: '餐厅',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/index'));
      });
    },
    name: 'CanteenList',
    meta: {
      title: '菜品列表',
      icon: ''
    }
  }, {
    path: 'cdkey',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/cdkey/index'));
      });
    },
    name: 'Cdkey',
    meta: {
      title: '卡密管理',
      icon: ''
    }
  }, {
    //id:卡密库id
    path: 'cdkey/creatCdkey/:id?/:name?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/cdkey/creatCdkey'));
      });
    },
    name: 'creatCdkey',
    meta: {
      title: '卡密添加',
      noCache: true,
      activeMenu: "/canteen/cdkey"
    },
    hidden: true
  }, {
    path: 'classify',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/classify/index'));
      });
    },
    name: 'classify',
    meta: {
      title: '菜品分类',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/attr/index'));
      });
    },
    name: 'CanteenAttr',
    meta: {
      title: '菜品规格',
      icon: ''
    }
  }, {
    path: 'comment',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/comment/index'));
      });
    },
    name: 'CanteenComment',
    meta: {
      title: '菜品评论',
      icon: ''
    }
  }, {
    //id:菜品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集菜品(1是，2不是),productType:菜品类型
    path: 'list/creatProduct/:id?/:isDisabled/:isCopy/:productType?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/creatProduct/index'));
      });
    },
    name: 'creatCanteen',
    meta: {
      title: '菜品添加',
      noCache: true,
      activeMenu: "/canteen/list"
    },
    hidden: true
  }, {
    path: 'guarantee/group',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/guarantee/index'));
      });
    },
    name: 'CanteenGuarantee',
    meta: {
      title: '保障服务组合',
      icon: ''
    }
  }, {
    path: 'label',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/canteen/label/index'));
      });
    },
    name: 'CanteenLabel',
    meta: {
      title: '菜品标签',
      icon: ''
    }
  }, {
    path: 'coupon/list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/coupon/list/index'));
      });
    },
    name: 'CanteenCouponList',
    meta: {
      title: '优惠券列表',
      icon: ''
    }
  }, {
    path: 'coupon/list/save',
    name: 'CanteenCouponAdd',
    meta: {
      title: '优惠劵添加',
      noCache: true,
      activeMenu: "/canteen/coupon/list"
    },
    hidden: true,
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/coupon/list/creatCoupon'));
      });
    }
  }, {
    path: 'coupon/list/save/:id?',
    name: 'CanteenCouponCopy',
    meta: {
      title: '优惠劵复制',
      noCache: true,
      activeMenu: "/canteen/coupon/list"
    },
    hidden: true,
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/coupon/list/creatCoupon'));
      });
    }
  }, {
    path: 'coupon/list/save/:id?/:edit?',
    name: 'CanteenCouponEdit',
    meta: {
      title: '优惠劵编辑',
      noCache: true,
      activeMenu: "/canteen/coupon/list"
    },
    hidden: true,
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/coupon/list/creatCoupon'));
      });
    }
  }, {
    path: 'coupon/record',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/coupon/record/index'));
      });
    },
    name: 'CanteenCouponRecord',
    meta: {
      title: '领取记录',
      icon: ''
    }
  }]
};
var _default = exports.default = canteenRouter;